/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'geofence': {
    width: 251,
    height: 251,
    viewBox: '0 0 251 251',
    data: '<defs/><path pid="0" id="geofence" class="cls-1" d="M1887.5 676.4a25.1 25.1 0 1 1 25.1-25.1 25.131 25.131 0 0 1-25.1 25.1zm0 150.6c-60.45 0-125.5-15.706-125.5-50.2 0-11.974 8.13-28.66 46.86-40.169l7.15 24.065c-23.88 7.089-28.91 14.878-28.91 16.1 0 6.458 34.52 25.1 100.4 25.1s100.4-18.642 100.4-25.1c0-1.226-4.99-8.983-28.73-16.049l7.16-24.058c38.58 11.483 46.67 28.152 46.67 40.107 0 34.498-65.05 50.204-125.5 50.204zm0-45l-8.87-8.886c-2.72-2.709-66.43-67.04-66.43-121.817a75.3 75.3 0 0 1 150.6 0c0 54.777-63.71 119.108-66.43 121.817zm0-180.9a50.257 50.257 0 0 0-50.2 50.2c0 31.345 30.87 72.769 50.2 94.578 19.33-21.809 50.2-63.233 50.2-94.578a50.257 50.257 0 0 0-50.2-50.2z" transform="translate(-1762 -576)"/>'
  }
})
